module.exports = __webpack_public_path__ + "static/media/iqra2.dff2445a.jpg";